// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"more-m__wrapper__2sxTa","content":"more-m__content__1XWY0","en-content":"more-m__en-content__2lUOO","bn-content":"more-m__bn-content__3Ppnx"};